module.exports = __webpack_public_path__ + "static/media/Malta.53d09b79.png";